export enum UserStatusTag {
  CONSENTER = '(※同意者)',
  DELETED = '(※解除済)',
  DEACTIVE = '(※停止中)',
}

export enum UserStatusTagNum {
  ACTIVE = 0,
  CONSENTER = 1,
  DELETED = 2,
  DEACTIVE = 3,
}
